import React from 'react';
import { Link, useParams } from 'react-router-dom';
import { Check, Package } from 'lucide-react';

const OrderSuccessPage = () => {
  const { orderNumber } = useParams();

  return (
    <div className="min-h-[80vh] flex items-center justify-center bg-yellow-300 p-6">
      <div className="bg-white border-4 border-black shadow-[16px_16px_0px_rgba(0,0,0,1)] max-w-lg w-full p-8 md:p-12 text-center">
        <div className="inline-block p-4 bg-black text-white rounded-full mb-6 animate-bounce">
          <Check size={56} strokeWidth={4} />
        </div>
        <h1 className="text-5xl md:text-6xl font-black uppercase tracking-tighter mb-4">ORDER PLACED</h1>
        <p className="font-mono font-bold text-base md:text-lg mb-2">WELCOME TO THE REVOLUTION.</p>
        {orderNumber && (
          <div className="bg-black text-white inline-block px-4 py-2 font-mono text-sm mt-4 mb-6 border-2 border-yellow-400">
            ORDER: {orderNumber}
          </div>
        )}
        <p className="text-gray-600 text-sm mb-8">
          Your order is being prepared. You'll receive an email confirmation shortly with tracking info.
        </p>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
          <Link
            to="/order/track"
            className="bg-yellow-400 text-black py-3 font-black uppercase border-4 border-black shadow-[4px_4px_0px_black] hover:shadow-none hover:translate-x-1 hover:translate-y-1 transition-all inline-flex items-center justify-center gap-2"
          >
            <Package size={20} /> Track Order
          </Link>
          <Link
            to="/"
            className="bg-white text-black py-3 font-black uppercase border-4 border-black hover:bg-gray-100"
          >
            Continue Shopping
          </Link>
        </div>
      </div>
    </div>
  );
};

export default OrderSuccessPage;
